module.exports = __webpack_public_path__ + "static/404.14e090e2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/404.svg
// module id = 852
// module chunks = 178469467687848